<template>
	<el-row class="homemainbigbox">
		<el-row class="main">
			<mainOne></mainOne>
			<mainTwo></mainTwo>
			<foot></foot>
		</el-row>
	</el-row>
</template>

<script>
	import mainOne from '@/views/news/components/mainOne.vue';
	import mainTwo from './components/mainTwo.vue';
	import foot from '@/views/foot/index.vue';
 export default {
		components:{
			mainOne:mainOne,
			mainTwo:mainTwo,
			foot:foot,
		},
        data(){
          return{

          }
        },
        methods:{

        },

}
</script>

<style lang="less" scoped>
	.homemainbigbox {
		width: 100%;
		height: auto;
		.main{
			height: auto;
			width: 100%;
		}
	}
</style>
